import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-waves-effects-inclusion-module',
	templateUrl:'./WavesEffectsInclusionModulePluginCompPage.html',
	styles: [],
	styleUrls:['./WavesEffectsInclusionModulePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesEffectsInclusionModulePluginCompPage
{
	mdContent_1159 = `\`\`\`java
import com.jwebmp.plugins.waveseffect.implementations.WavesEffectsInclusionModule;
\`\`\``;
}
